import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { InputType } from '@agilent/ui-element';

@Component({
    selector: 'app-input-wrapper',
    template: `
        <div 
            [ngClass]='form-field-loader-container'>

            <ag-input
                [(ngModel)]="value"
                [errorMessage]="errorMessage || getErrorMsg()"
                (touched)="fieldTouched()"
                [disabled]="disabled || isDisabled || isLoading"
                (blur)="onBlur($event)"
                [maxlength]="maxlength"
                [valueType]="valueType"
                (ngModelChange)="valueChanged($event)"
                [label]="required ? label + ' *' : label">
            </ag-input>
            <ag-loader
                class="form-field-loader"
                [visible]="isLoading"
                [position]="'relative'"
                [small]="true"></ag-loader>
            <span
                [ngClass]="errorMessage || getErrorMsg()
                ? 'form-field-description-pushed-down'
                : 'form-field-description'">
                {{description}}
            </span>
        </div>
    `
})
export class AppInputWrapperComponent implements OnChanges, ControlValueAccessor {
    @Input() required = false;
    @Input() label: string;
    @Input() errorMessage: string;
    @Input() valueType: InputType;
    @Input() maxlength: number;
    @Input() isLoading: boolean;
    @Input() description: string;
    isDisabled: boolean;
    @Input() disabled: boolean;
    minLength = 1;
    value: any;
    onChange: (value) => void;
    onTouched: () => void;

    constructor(private formControl: NgControl) {
        this.formControl.valueAccessor = this;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.errorMessage && !changes.errorMessage.firstChange) {
            this.errorMessage = changes.errorMessage.currentValue;
        }
        if (changes.isLoading) {
            this.isLoading = changes.isLoading.currentValue;
        }
    }

    getErrorMsg() {
        const errors = this.formControl.control.errors || {};
        if (!this.formControl.control.touched) {
            return;
        }

        if ('required' in errors || (this.required && !this.value)) {
            return 'This field is required';
        }

        // Handle our custom validators error message
        const errorObj = Object.values(errors)[0];
        if (errorObj && errorObj.hasOwnProperty('errorLabel')) {
            return errorObj['errorLabel'];
        }

        if ('minlength' in errors) {
            return `Enter ${this.minLength} or more characters`;
        }
        if ('email' in errors) {
            return 'Should be a valid email address';
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(obj: any): void {
        this.value = obj;
    }

    setDisabledState(isDisabled: boolean) {
        this.isDisabled = isDisabled;
    }

    valueChanged(newValue) {
        this.onChange(newValue);
        this.onTouched();
    }

    fieldTouched() {
        this.onTouched();
    }

    onBlur($event) {
        this.onTouched();
    }
}
